import { IFieldAccessType } from '../../../../../component/admin-module/module/users/interface/field';
import ValidateField from '../../../validation';
import { IValidationError } from '../../../validation/type/validation-type';
import { FieldElement } from '../../field-element';
import { TValidationType, PropType } from '../field-properties.handler';

export interface INumberProps {
  value: string | number;
  fieldType?: string;
  error?: IValidationError[];
}

export class NumberProps extends PropType<INumberProps, INumberProps> {

  _parseNumberValue = (value: string) => {
    if (value && typeof value === 'string') {
      const hasComma = value.indexOf(',') > -1;
      return parseFloat(hasComma ? value.replace(/,/g, '') : value);
    }
    return value;
  }


  processValueFromRef(props: INumberProps): INumberProps {
    const value = typeof props.value !== 'undefined' && props.value !== null ? `${props.value}` : null;
    props.value = value !== null ? this._parseNumberValue(value) : '';
    return props;
  }

  processValueToRef(newProps: INumberProps): INumberProps {
    const value = typeof newProps.value !== 'undefined' && newProps.value !== null ? `${newProps.value}` : null;
    newProps.value = value !== null ? this._parseNumberValue(value) : '';
    return newProps;
  }

  processValidation(data: INumberProps, field: FieldElement, validationType: TValidationType): IValidationError[] {
    const value = data.value;
    const validateField = new ValidateField();
    const validate = validateField.singleField(field, value, validationType);
    return field.accessType === IFieldAccessType.Required || !!value ? validate : [];
  }
}